module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": _vm.dense
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", item)
        }
      }
    }, [_vm._t("avatar-before", function() {
      return [(_vm.avatarPosition === "before" && _vm.avatarPath) ? _c('v-list-tile-avatar', [_c('img', {
        attrs: {
          "src": _vm.getObjectPath(item, _vm.avatarPath)
        }
      })]) : _vm._e()]
    }, {
      "item": item
    }), _vm._v(" "), _c('v-list-tile-content', [_vm._t("title", function() {
      return [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.getObjectPath(item, _vm.titlePath)) + "\n      ")])]
    }, {
      "item": item
    }), _vm._v(" "), _vm._t("subtitle", function() {
      return [(_vm.subTitlePath) ? _c('v-list-tile-sub-title', [_vm._v("\n        " + _vm._s(_vm.getObjectPath(item, _vm.subTitlePath)) + "\n      ")]) : _vm._e()]
    }, {
      "item": item
    })], 2), _vm._v(" "), _vm._t("avatar-after", function() {
      return [(_vm.avatarPosition === "after" && _vm.avatarPath) ? _c('v-list-tile-avatar', [_c('img', {
        attrs: {
          "src": _vm.getObjectPath(item, _vm.avatarPath)
        }
      })]) : _vm._e()]
    }, {
      "item": item
    })], 2), _vm._v(" "), (_vm.withDivider) ? _c('v-divider', {
      key: ("div-" + index)
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b930a54","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/DataList.vue
// module id = 1436
// module chunks = 9